export default "__VITE_ASSET__D2rGI1Ny__"